import * as React from "react";

export function useDialogClose(enabled: boolean, callback: () => void) {
  const callbackRef = React.useRef(callback);
  const firstRenderRef = React.useRef(true);

  React.useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }

    const cb = callbackRef.current;

    return () => {
      if (enabled) cb();
    };
  }, [enabled]);
}
